module.exports = __webpack_public_path__ + "img/avatar3.1e9af993.png";